import {
  FilterBatteryStatusState,
  FilterDeviceGroupsState,
  FilterDeviceTypeState,
  FilterOfficeModeState
} from './deviceFilterTypes';

export const filterDeviceGroupsDefault: FilterDeviceGroupsState = null;

export const filterDeviceTypeDefault: FilterDeviceTypeState = {
  reader: false,
  controller: false,
  handle: false,
  swingHandle: false,
  cylinder: false,
  locker: false
};

export const filterBatteryStatusDefault: FilterBatteryStatusState = {
  unknown: false,
  empty: false,
  critical: false,
  low: false,
  full: false
};

export const filterOfficeModeDefault: FilterOfficeModeState = null;
